//src/Components/EmojiPicker/data.ts
import EmojiMartData from '@emoji-mart/data';

export const Emojis = EmojiMartData;
